import { TableRow } from '@mui/material';
import { BaseTableRowProps } from './BaseTableRow.types';

/**
 * The base MUI TableRow used as an entry point and as separation for mocking.
 *
 * @param classes - {@link BaseTableRowProps.classes classes} description.
 * @param children - {@link BaseTableRowProps.children children} description.
 */
export const BaseTableRow = ({
    classes,
    children,
}: BaseTableRowProps) => {
    return (
        <TableRow
            classes={{
                ...classes,
            }}
        >
            {children}
        </TableRow>
    );
};